import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { message } from 'antd';
import DoughnutChart from 'components/Charts/DoughnutChart';
import { DashboardChartProps } from 'pages/Dashboard/Charts/types';
import coursesApiClient from 'utils/coursesApiClient';

const ActiveStudentsChart: React.FC<DashboardChartProps> = ({ customerUuid }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    data: {},
    inner: {},
  });

  const intl = useIntl();

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);

        const url = `/api/v1/courses/statistic/dashboard/campaigns/customer/${customerUuid}/active-students`;
        const response = await coursesApiClient.request(url);
        const responseData = response.statistic;

        const data = {
          data: [
            responseData.enrolled,
            responseData.other,
          ],
          total: responseData.total,
        };

        const parsedData = {
          data: {
            labels: [
              intl.formatMessage({ id: 'campaign.currently_enrolled_in_learning_campaign' }),
              intl.formatMessage({ id: 'campaign.no_active_learning_objectives' }),
            ],
            datasets: [{
              data: data.data,
              backgroundColor: [
                'rgb(33, 208, 160)',
                'rgb(244, 98, 100)',
              ],
              hoverBackgroundColor: [
                'rgb(13, 188, 140)',
                'rgb(224 ,68, 80)',
              ],
            }],
          },
          inner: {
            text: intl.formatMessage({ id: 'organization.active_students' }),
            number: data.total,
          },
        };

        setData(parsedData);
      } catch (error) {
        console.error(error);
        message.error(intl.formatMessage({ id: 'error.data_load' }));
      } finally {
        setIsLoading(false);
      }
    }

    loadData();
  }, [intl, customerUuid]);

  return (
    <DoughnutChart
      data={data.data}
      title={intl.formatMessage({ id: 'campaign.number_of_active_students' })}
      showLabelValues={false}
      inner={data.inner}
      loading={isLoading}
    />
  );
}

export default ActiveStudentsChart;